/** zh-CN catalogue `assets` (W3-09; English: src/features/assets/assets.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const catalog: MessageCatalog = {
  ns: 'assets',
  locale: 'zh-CN',
  messages: {
    panelTitle: '素材',
    summary: '{count, plural, other {# 个文件}} · {size}',
    addFile: '添加文件',
    usedListLabel: '使用中的文件',
    unusedListLabel: '未使用的文件',
    unusedTitle: '未使用（{count}）',
    removeAllUnused: '移除全部未使用的文件',
    emptyTitle: '还没有文件',
    emptyBody: '谱面的曲目、曲绘、判定线图片、GIF、打击音、着色器和视频会显示在这里。',
    noProjectTitle: '没有打开的谱面',
    noProjectBody: '打开一张谱面以查看其文件。',
    dimensions: '{width} x {height} px',
    namingRules:
      '谱面包中的文件名使用纯 ASCII 字符，且永远不以“click.png”结尾（否则 Phira 会把谱面包当作皮肤）；自定义打击音的文件名永远不能正好是 tap.mp3、flick.mp3 或 drag.mp3（对这些文件名 Phira 会播放内置音效）。',
    chooseFile: '选择文件…',
    replaceLabel: '替换 {name}',
    renameAction: '重命名 {name}',
    renameLabel: '谱面包中的文件名',
    downscaleLabel: '缩小 {name}',
    downloadLabel: '下载 {name}',
    removeLabel: '移除 {name}',
    roleMusic: '曲目',
    roleIllustration: '曲绘',
    roleTexture: '图片',
    roleGif: 'GIF',
    roleHitsound: '打击音',
    roleShader: '着色器',
    roleVideo: '视频',
    roleFont: '字体',
    roleOther: '其他文件',
    usedBy: '使用者：{users}',
    usedSong: '谱面的曲目',
    usedIllustration: '曲绘',
    usedUnlockVideo: '解锁视频',
    usedLines: '{count, plural, other {# 条判定线}}',
    usedNotes: '{count, plural, other {# 个音符}}',
    usedEffects: '{count, plural, other {# 个特效}}',
    usedVideos: '{count, plural, other {# 个视频}}',
    unused: '未使用',
    badgeMissing: '缺失',
    badgeMissingTip: '谱面使用了此文件，但它不在导入的谱面包中。在选择文件或移除引用之前，Phira 无法加载谱面。',
    badgeUndecodable: 'Phira 无法读取',
    badgeUndecodableTip:
      'Phira 无法解码此格式（{codec}）。请替换为 OGG、MP3、WAV 或 FLAC 音频，或 PNG、JPG、WebP 图片。',
    badgeName: '文件名',
    nameReserved: 'Phira 保留了此文件名（谱面包顶层的“export.json”或“line.png”）。请重命名文件。',
    nameClickPng: '以“click.png”结尾的文件名会让 Phira 把谱面包当作皮肤。请重命名文件。',
    nameBuiltinHitsound: '名为 tap.mp3、flick.mp3 或 drag.mp3 的打击音，Phira 会播放其内置音效。请重命名文件。',
    nameInvalid: '此文件名不能用于谱面包（空文件夹、“..”、开头的“/”或反斜杠）。请重命名文件。',
    badgeNonAscii: '非 ASCII 文件名',
    badgeNonAsciiTip: '部分工具解包时会弄乱非纯 ASCII 的文件名。使用纯 ASCII 文件名更安全。',
    badgeLarge: '{width} x {height}',
    badgeLargeTip: 'Phira 绘制图片时不使用 mipmap：大于 2048 px 的图片缩小时会闪烁，并占用更多内存。请将其缩小。',
    addTxnOne: '添加文件 {name}',
    addTxnMany: '添加 {count} 个文件',
    addedOne: '已添加 {name}。',
    addedMany: '已添加 {count} 个文件。',
    alreadyAdded: '{name} 已作为 {path} 在谱面中。',
    readFailed: '无法读取 {name}：{reason}',
    storeFailed: '无法存储 {name}：{reason}',
    wrongKind: '{name} 不能用作{role}。',
    largeTitle: '{name} 为 {width} x {height} px',
    largeBody:
      'Phira 绘制图片时不使用 mipmap，因此大于 {limit} px 的图片缩小时会闪烁。较小的副本在手机上看起来一样，加载也更快。',
    downscaleTo: '将最长边缩小为 {side} px',
    keepOriginal: '保持原始尺寸',
    keepOriginalHelp: '谱面检查会保留一条相关提示。',
    downscaleFailed: '无法缩小图片：{reason}',
    replaceTxn: '用 {to} 替换 {from}',
    replaced: '已用 {to} 替换 {from}。',
    sameFile: '{name} 是同一个文件：没有任何更改。',
    gone: '此文件已不在谱面中。',
    songUndecodable: '此浏览器无法播放 {name}，因此未将其用作曲目。',
    songLoadFailed: '无法加载新曲目用于播放：{reason}',
    previewTitle: '选曲预览已超出曲目范围',
    previewBody:
      '新曲目长 {length}，但预览播放的是 {start} 到 {end}。如果预览在曲目结束之后才结束，Phira 会拒绝打开谱面。',
    previewFix: '将预览移到曲目范围内',
    previewFixHelp: '预览变为 {start} 到 {end}。',
    previewKeep: '保持预览不变',
    previewKeepHelp: '在你修改之前，“问题”选项卡会将其显示为错误。',
    removeTxn: '移除文件 {name}',
    removed: '已移除 {name}。',
    removeUsedTitle: '移除 {name}？',
    removeUsedBody:
      '{users}。相关引用也会被移除：判定线恢复为内置的判定线图片，音符恢复为正常音效，使用它的特效或视频会被删除。此操作可以撤销。',
    removeSongBody: '{users}。在你选择新曲目之前谱面将没有曲目，也无法导出。此操作可以撤销。',
    removeConfirm: '移除',
    removeUnusedTitle: '移除 {count, plural, other {# 个未使用的文件}}？',
    removeUnusedBody: '谱面中没有任何内容使用它们。此操作可以撤销。',
    removeUnusedTxn: '移除 {count, plural, other {# 个未使用的文件}}',
    removedUnused: '已移除 {count, plural, other {# 个未使用的文件}}。',
    noneUnused: '所有文件都在使用中。',
    renameTxn: '将文件 {from} 重命名为 {to}',
    renamed: '已重命名为 {name}。',
    downscaleTxn: '将 {name} 缩小为 {side} px',
    downscaled: '{name} 的最长边现在为 {side} px。',
    notLarge: '{name} 不大于 {limit} px。',
    missingNoDownload: '此文件缺失：没有可下载的内容。',
    sizeB: '{size} B',
    sizeKB: '{size} KB',
    sizeMB: '{size} MB',
    sizeGB: '{size} GB',
    sizeTB: '{size} TB',
    cmdShow: '素材',
    cmdAdd: '向谱面添加文件…',
    cmdReplace: '替换文件…',
    cmdRemove: '移除文件',
    cmdRename: '重命名文件',
    cmdDownscale: '缩小图片…',
    cmdDownload: '下载文件',
    cmdRemoveUnused: '移除未使用的文件',
    reasonNoProject: '请先打开一张谱面。',
    pickAsset: '请在“素材”选项卡中选择一个文件。',
    helpTitle: '谱面的文件',
    helpBody:
      '“素材”选项卡列出谱面的每个文件：曲目、曲绘、判定线图片和 GIF、打击音、着色器和视频，以及各自的使用者。替换文件可让所有使用处改为指向另一个文件（用于缺失的文件或新曲目）；也可以重命名、缩小大图片或移除文件。即使多张谱面使用同一文件，它也只存储一次。Phira 需要纯 ASCII 且不以“click.png”结尾的文件名；对名为 tap.mp3、flick.mp3 或 drag.mp3 的打击音，Phira 会播放自己的音效。',
    badgeStorageMissing: '此浏览器中缺失',
    badgeStorageMissingTip:
      '谱面列出了此文件，但浏览器中已没有它的数据。再次选择同一文件即可恢复；在此之前谱面无法导出。',
    fileRestored: '{name} 已恢复：文件已重新存储在此浏览器中。',
    showFiles: '显示文件',
    songRestored: '曲目 {name} 已恢复：它已重新存储在此浏览器中，并已加载用于播放。',
    storageMissingMany: '此浏览器的存储中缺少 {count, plural, other {# 个文件}}：{names}。请在“素材”中重新选择它们。',
    storageMissingOne: '此浏览器的存储中缺少文件 {name}。再次选择同一文件即可恢复。',
  },
};

export default catalog;
